import { ENV_FILE_TOKEN } from "../constants/env-token";
import { FactoryProvider } from "@angular/core";
import { EnvConfig } from "../models/env-config";
import { environment } from "../constants/environment";

export function provideEnvFile(productStage: string | undefined = undefined): FactoryProvider {
  return {
    provide: ENV_FILE_TOKEN,
    useFactory: () => {
      if (productStage && productStage.toLowerCase() === "dtz") {
        return { ...environment, envName: "local-dtz" } as EnvConfig;
      } else if (productStage && productStage.toLowerCase() === "inl") {
        return { ...environment, envName: "local-inl" } as EnvConfig;
      } else {
        return { ...environment };
      }
    },
  };
}
